import { CommandParser } from '../client/parser';
import { RedisArgument, BlobStringReply, NullReply, Command } from '../RESP/types';

export default {
  parseCommand(parser: CommandParser, source: RedisArgument, destination: RedisArgument, timeout: number) {
    parser.push('BRPOPLPUSH');
    parser.pushKeys([source, destination]);
    parser.push(timeout.toString());
  },
  transformReply: undefined as unknown as () => BlobStringReply | NullReply
} as const satisfies Command;
